const en = {
  nav: {
    about: 'About',
    resume: 'Resume',
    projects: 'Projects',
    contact: 'Contact',
  },
  projects: {
    title: 'Projects',
    subtitle: 'Projects I\'ve worked on',
  },
  sidebar: {
    about: 'About',
    description: 'Hi, I\'m Mustafa. I graduated from Erciyes University and I\'m currently working as an Expert Software Engineer at Yapı Kredi Technology. I design and build fullstack applications using Java Spring Boot microservices and React-based frontends within the financial domain.',
    learnMore: 'Learn More',
    aboutMe: 'About Me',
  },
  index: {
    greeting: 'Feel free to get in touch. You can email me at:',
  },
  about: {
    title: 'About Me',
    wordCount: '(in about {count} words)',
  },
  resume: {
    title: 'Resume',
    education: 'Education',
    experience: 'Experience',
    techStacks: 'Tech Stacks',
    awards: 'Awards',
    present: 'PRESENT',
    downloadCV: 'Download CV',
    preparingCV: 'Preparing CV',
    downloadFailed: 'The download could not be completed. Please try again.',
  },
  contact: {
    title: 'Contact',
    description: 'Feel free to get in touch. You can email me at:',
    formTitle: 'Or send me a message',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    send: 'Send Message',
    sending: 'Sending...',
    sent: 'Thanks! Your message has been sent.',
    error: 'Your message could not be sent. Please try again later.',
    verificationFailed: 'Verification failed. Please try again.',
  },
  notFound: {
    title: 'Page Not Found',
    returnHome: 'Return',
    home: 'home',
  },
  awards: {
    issuedBy: 'Issued by',
  },
};

export default en;
